import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
  }

  #root {
    min-height: 100%;
    min-width: 100%;
    font-size: 16px;
    font-family: 'Inter', sans-serif;
  }

  body,
  span,
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  label,
  input,
  span,
  select, button {
    font-family: 'Inter', sans-serif;
  }

  input, select {
    font-size: inherit;
  }
`;
